import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="border-t border-[#1D1F21]" style={{ background: "var(--lrg-bg)" }} data-testid="footer">
    <div className="container-custom py-20 pb-28 md:pb-20">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-14 mb-16">
        <div>
          <Link to="/" className="inline-flex items-center gap-2 mb-6">
            <div className="w-1.5 h-1.5 bg-[#0D6B56] rounded-full"></div>
            <span className="font-display text-sm font-semibold text-[#F2EDE4]">LRG Squash</span>
          </Link>
          <p className="text-[11px] text-[#3A3D40] leading-[1.8]">
            Train with purpose.<br />Compete with confidence.
          </p>
        </div>

        <div>
          <h4 className="text-[9px] font-medium uppercase tracking-[0.25em] text-[#3A3D40] mb-6">Training</h4>
          <ul className="space-y-3">
            <li><Link to="/college-consulting" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">College Consulting</Link></li>
            <li><Link to="/contact" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[9px] font-medium uppercase tracking-[0.25em] text-[#3A3D40] mb-6">Baltimore</h4>
          <ul className="space-y-3">
            <li><Link to="/baltimore" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Location</Link></li>
            <li><a href="mailto:dreadsports.baltimore@gmail.com?subject=Court%20Booking%20Request%20%E2%80%94%20Baltimore" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Book Court by Email</a></li>
            <li><a href="mailto:dreadsports.baltimore@gmail.com" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">dreadsports.baltimore@gmail.com</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-[9px] font-medium uppercase tracking-[0.25em] text-[#3A3D40] mb-6">Princeton</h4>
          <ul className="space-y-3">
            <li><Link to="/princeton" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Location</Link></li>
            <li><a href="https://njsc.clubautomation.com" target="_blank" rel="noopener noreferrer" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Book Court</a></li>
            <li><a href="mailto:Njsquashclub@gmail.com" className="text-[11px] text-[#6B6E71] hover:text-[#0D6B56] transition-colors duration-400">Njsquashclub@gmail.com</a></li>
          </ul>
        </div>
      </div>

      <div className="divider-thin mb-6"></div>
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-[10px] text-[#3A3D40] tracking-wider">&copy; {new Date().getFullYear()} LRG Squash</p>
        <a href="https://www.instagram.com/dread_sports" target="_blank" rel="noopener noreferrer" className="text-[10px] text-[#3A3D40] hover:text-[#0D6B56] transition-colors uppercase tracking-[0.2em]">Instagram</a>
      </div>
    </div>
  </footer>
);

export default Footer;
